export { j as AUTH_ACTION, l as AddonEventTarget, f as AddonListChannel, o as AddonMallPageType, e as AddonScenes, h as AddonWindowType, D as DocAddonBridge, d as DocElementType, c as DocHook, m as DriveAddonManager, F as FORMULA_ADDON_ID, k as LINK_ADDON_ID, i as LinkType, n as MallManager, M as MenuConfigurationType, O as OfficialAddonType, P as PrintMode, R as REPORT_VALID_LIST, p as SDKUnofficialAddonToolbarKey, S as SIGN_ADDON_ID } from './index-eab1fc93.js';
export { ActionName, DocElementType as AddonDocElementType, FileType, ImageSourceType, MenuType, ResizeMode, ToolbarButtonType } from '@tencent/td-open-common-interfaces';
import 'tslib';
import '@tencent/td-open-common-utils';
import 'uuid';
import '@tencent/docs-multi-tools';
import 'axios';
import '@tencent/docs-user-agent';
import '@tencent/tencent_doc_open_url';
import 'react';
import '@tencent/workbench';
import '@tencent/dui-mobile';
import 'react-dom';
import '@tencent/docs-config';
import '@tencent/txdocs-aid';
import '@tencent/dui';
import 'i18next';
import '@tencent/docs-miniapp-sdk';
import 'url-parse';
import 'dayjs';
import '@tencent/td-open-report';
//# sourceMappingURL=index.js.map
